import { Group } from '@/components/_common';
import StatusTag from '@/components/_common/StatusTag';
import { useInvoiceCFEFormContext } from '../InvoiceCFEFormProvider';
import {
  TaxCouponStatusColor,
  TaxCouponStatusLabel,
} from '@/core/domain/coupon/coupons/coupons.types';
import { Col, Divider, Row, Typography } from 'antd';

interface Props {
  extra?: React.ReactNode;
}

const InvoiceCFEHeader: React.FC<Props> = ({ extra }) => {
  const { taxCoupon } = useInvoiceCFEFormContext();

  if (!taxCoupon) return null;

  return (
    <>
      <Row
        gutter={[24, 24]}
        justify="space-between"
        wrap={false}
        align="middle"
      >
        <Col span={24} md={12}>
          <Group gap={16}>
            <Typography.Title level={4} style={{ margin: 0 }}>
              Situação:
            </Typography.Title>

            <StatusTag
              label={TaxCouponStatusLabel[taxCoupon.status]}
              color={TaxCouponStatusColor[taxCoupon.status]}
            />
          </Group>
        </Col>

        <Col>
          <Row align="middle" gutter={[24, 24]}>
            <Col>
              <Group gap={8}>
                <Typography.Text strong>Núm. Cupom:</Typography.Text>
                <Typography.Text>
                  {taxCoupon.sefazBreakdown?.cfeNumber || '-'}
                </Typography.Text>
              </Group>
            </Col>

            {!!extra && (
              <>
                <Col>
                  <Divider type="vertical" />
                </Col>
                <Col>{extra}</Col>
              </>
            )}
          </Row>
        </Col>
      </Row>

      <Divider />
    </>
  );
};

export default InvoiceCFEHeader;
